import { AppointmentParticipantType } from '@generated/gql/graphql';

const accordions = {
  [AppointmentParticipantType.Partner]: [
    {
      value: 'join',
      title: 'Create and join the lobby',
    },
  ],
  [AppointmentParticipantType.Customer]: [
    {
      value: 'name',
      title: 'Your name',
    },
    {
      value: 'join',
      title: 'Get ready',
    },
  ],
  [AppointmentParticipantType.SupportingPartner]: [
    {
      value: 'join',
      title: 'Get ready',
    },
  ],
};

export { accordions };
